import React from 'react';
import { motion } from "motion/react";
import styled from 'styled-components';

const AnimatedCheckmark = (props) => {
    return (
        <Wrapper>
            <CircleContainer
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.05 }}
            >
                <CircleSvg fill="none" preserveAspectRatio="none" viewBox="0 0 60 60">
                    <motion.circle
                        cx="30"
                        cy="30"
                        r="29"
                        stroke="#212121"
                        strokeWidth="2"
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        transition={{
                            duration: 0.5,
                            ease: [0.4, 0, 0.2, 1]
                        }}
                    />
                </CircleSvg>
            </CircleContainer>
            <CheckContainer
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.05, delay: 0.45 }}
            >
                <svg width="24" height="20" viewBox="0 0 24 20" fill="none">
                    <motion.path
                        d="M2 10L9 17L22 3"
                        stroke="#212121"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        transition={{
                            duration: 0.3,
                            delay: 0.45,
                            ease: [0.4, 0, 0.2, 1]
                        }}
                    />
                </svg>
            </CheckContainer>
        </Wrapper>
    );
};

export default AnimatedCheckmark;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
`;

const CircleContainer = styled(motion.div)`
    position: relative;
    width: 60px;
    height: 60px;
    flex-shrink: 0;
`;

const CircleSvg = styled.svg`
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`;

const CheckContainer = styled(motion.div)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

